export default "__VITE_ASSET__aa0c81eb__"